import { render } from "./LawsuitReceiptReport.vue?vue&type=template&id=2d0065e1&scoped=true"
import script from "./LawsuitReceiptReport.vue?vue&type=script&lang=js"
export * from "./LawsuitReceiptReport.vue?vue&type=script&lang=js"

import "./LawsuitReceiptReport.vue?vue&type=style&index=0&id=2d0065e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0065e1"]])

export default __exports__